export const diccionario: { [key: string]: string } = {
  // --- Palabras muy frecuentes ---
  esta: 'está', // Dependiendo del contexto, pero suele faltar en verbos
  aqui: 'aquí',
  alli: 'allí',
  despues: 'después',
  asi: 'así',
  tambien: 'también',
  mas: 'más',
  dia: 'día',
  ultimo: 'último',
  proximo: 'próximo',
  pagina: 'página',
  numero: 'número',
  facil: 'fácil',
  dificil: 'difícil',
  arbol: 'árbol',

  // --- Terminaciones en "ción" (Sustantivos) ---
  atencion: 'atención',
  informacion: 'información',
  seccion: 'sección',
  comunicacion: 'comunicación',
  opcion: 'opción',
  direccion: 'dirección',
  educacion: 'educación',
  nacion: 'nación',
  accion: 'acción',
  descripcion: 'descripción',
  solucion: 'solución',
  administracion: 'administración',

  // --- Verbos en pasado (3ra persona) ---
  publico: 'publicó',
  envió: 'envió',
  compro: 'compró',
  busco: 'buscó',
  llego: 'llegó',
  paso: 'pasó',

  // --- Tecnología y Web ---
  codigo: 'código',
  menu: 'menú',
  usuario: 'usuário',
  contraseña: 'contraseña', // (Ya tiene eñe, pero a veces falta la tilde en otras)
  computacion: 'computación',
  tecnologia: 'tecnología',
  video: 'vídeo', // En Latam se usa más "video" sin tilde, pero en algunos países lleva.
  imagenes: 'imágenes',
  grafico: 'gráfico',

  // --- Países y Gentilicios ---
  mexico: 'México',
  peru: 'Perú',
  panama: 'Panamá',
  bogota: 'Bogotá',
  canada: 'Canadá',

  // --- Pronombres y Adverbios ---
  tu: 'tú',
  el: 'él',
  si: 'sí',
  como: 'cómo',
  que: 'qué',
  donde: 'dónde',
  cuando: 'cuándo',
  quien: 'quién',
  cual: 'cuál',
  cuanto: 'cuánto',
  aun: 'aún',
  solo: 'sólo',
  se: 'sé',
  aquel: 'aquél',
  este: 'éste',
  ese: 'ése',
  ahi: 'ahí',
  quizas: 'quizás',

  // --- Verbos (Futuro y Condicional) ---
  sera: 'será',
  estara: 'estará',
  podra: 'podrá',
  habra: 'habrá',
  podria: 'podría',
  seria: 'sería',
  haria: 'haría',
  tendria: 'tendría',
  podiamos: 'podíamos',
  seriamos: 'seríamos',

  // --- Sustantivos y Adjetivos Varios ---
  util: 'útil',
  carcel: 'cárcel',
  angel: 'ángel',
  torax: 'tórax',
  lapiz: 'lápiz',
  fenix: 'fénix',
  buho: 'búho',
  musica: 'música',
  quimico: 'químico',
  tecnico: 'técnico',
  basico: 'básico',
  brocoli: 'brócoli',
  telefono: 'teléfono',
  heroe: 'héroe',
  periodico: 'periódico',
  cafe: 'café',
  corazon: 'corazón',
  cancion: 'canción',
  atun: 'atún',
  jamon: 'jamón',
  sofa: 'sofá',
  balcon: 'balcón',
  adios: 'adiós',
  compas: 'compás',
  estres: 'estrés',
  imaginacion: 'imaginación',
  organizacion: 'organización',
  construccion: 'construcción',
  repeticion: 'repetición',
  decision: 'decisión',
};
